import React from 'react';
import Select from 'react-select';
import { AgentIcons } from '../data/AgentIcons';
import { customDarkSelectStyles } from './CustomDarkSelectStyles';


const AgentCustomSelect = ({ selectedOption, onOptionChange }) => {

  const customOption = ({ innerProps, label, value, isFocused }) => (
    <div
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 10px',
        backgroundColor: isFocused ? '#3a3a3a' : '#2c2c2c',
        color: '#f1f1f1',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease-in-out',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#4a4a4a')}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = isFocused ? '#3a3a3a' : '#2c2c2c')}
    >
      <img src={AgentIcons[label]} alt="" style={{ width: '24px', height: '24px', borderRadius: '3px', objectFit: 'contain', }} />
      {label}
    </div>
  );

  let options = Object.keys(AgentIcons).map((agent) => ({
    value: agent,
    label: agent,
  }));

  return (
    <Select
      hideSelectedOptions={selectedOption.length < 3 ? true : false}
      isMulti
      options={options}
      onChange={(selectedOptions) => onOptionChange(selectedOptions)}
      value={selectedOption}
      components={{ Option: customOption }}
      styles={customDarkSelectStyles}
      placeholder={"Agents"}
    />
  );
};

export default AgentCustomSelect;
